// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import Image from '@tcp/core/src/components/common/atoms/Image';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

const getNewPJPRedesignIfEnabled = (props) => {
  return props.pageName === 'PDP' && props.isNewPJPPDPRedesignEnabled
    ? `font-size: ${props.theme.fonts.fontSize.body.bodytext.copy3}px;
   font-weight: ${props.theme.fonts.fontWeight.semiBold};
   color: ${props.theme.colors.BUTTON.BLUE.NEW_FILTER_BTN};`
    : '';
};

export const ProductRatingWrapper = styled.div`
  ${(props) =>
    props?.isTileRedesignAB || props?.isRatingRedesignAbTest
      ? ''
      : 'min-height: 23px;height: 22px;'}
  ${(props) =>
    props.pageName === 'PDP' &&
    props.isNewPJPPDPRedesignEnabled &&
    `padding-top: ${props.theme.spacing.ELEM_SPACING.XS_1};
  padding-bottom: ${props.theme.spacing.ELEM_SPACING.XS_1};
  border-top: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};
  border-bottom: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};
  @media ${props.theme.mediaQuery.smallOnly} {
    padding-top: ${props.theme.spacing.ELEM_SPACING.XS};
    padding-bottom: ${props.theme.spacing.ELEM_SPACING.XS};
  }`}

  /* Using !important to override bazaar voice plugin css, unable to achieve via increasing the specificity */
  [data-bv-show='rating_summary'] .bv_main_container {
    button.bv_main_container_row_flex {
      display: none !important;
    }
    button.bv_button_buttonMinimalist {
      white-space: nowrap !important;
    }
    .bv_main_container_row_flex {
      padding-right: 0 !important;
    }
  }

  &.ranking-container {
    .bv-core-container-311 .bv-summary-bar-minimalist-horizontal .bv-stars-container {
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.LRG} !important;
    }

    .bv-stars-container .bv-rating-ratio {
      padding-right: 0 !important;

      .bv-rating-stars-container .bv-rating-stars {
        letter-spacing: 8px !important;
      }

      .bv-rating-stars-on {
        color: ${(props) => props.theme.colorPalette.yellow[600]} !important;
      }
    }

    .bv-summary-bar-minimalist .bv-write-container .bv-submission-button.bv-write-review {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14} !important;
      font-family: 'Nunito' !important;
      color: ${(props) => props.theme.colorPalette.gray[900]} !important;
    }

    .bv-summary-bar .bv-rating-ratio-number {
      padding-right: 0 !important;
    }
  }
  &.guest {
    #WAR {
      display: none !important;
    }
  }
  &.rating_summary {
    height: 20px;
  }
  &.logged-in {
    #WAR-login1,
    #WAR-login2 {
      display: none !important;
    }
  }

  &.rating-wrapper-new-pdp {
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-top: 15px;
    }
  }
  &.rating-wrapper-new-pdp-redesign {
    border: none;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      padding: 0;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0;
    }

    .ranking-wrapper {
      @media ${(props) => props.theme.mediaQuery.medium} {
        justify-content: unset;
      }
    }

    .ratings-container {
      @media ${(props) => props.theme.mediaQuery.medium} {
        padding-left: 0;
      }
    }
  }
  .newwrite-review-link {
    text-decoration: underline;
    cursor: pointer;
    text-transform: lowercase;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      color: ${(props) => props.theme.colorPalette.gray[900]};
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    }
    ${(props) => getNewPJPRedesignIfEnabled(props)}
    &::first-letter {
      text-transform: uppercase;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-top: 2px;
    }
  }
`;

export const RatingsContainer = styled.div`
  ${(props) => (props?.isTileRedesignAB || props?.isRatingRedesignAbTest ? '' : 'height: 22px;')}
  margin-right: 8px;
  ${(props) =>
    props.pageName === 'PDP' &&
    props.isNewPJPPDPRedesignEnabled &&
    `@media ${props.theme.mediaQuery.medium} {
    padding-left:${props.theme.spacing.ELEM_SPACING.SM};
  }`}

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    ${(props) => props.isPDPRedesignEnabled && `padding-left:0; `}
  }
`;

export const WriteReviewLink = styled.div`
  margin-top: 1px;
  ${(props) =>
    props.pageName === 'PDP' && props.isNewPJPPDPRedesignEnabled
      ? `&&& {
 .bv_button_buttonMinimalist{
 color: ${props.theme.colors.BUTTON.BLUE.NEW_FILTER_BTN} !important;
 font-size: ${props.theme.fonts.fontSize.body.bodytext.copy3}px !important;
 font-weight: ${props.theme.fonts.fontWeight.semiBold} !important;}
 .bv_button_buttonMinimalist:hover{
  color: ${props.theme.colors.BUTTON.BLUE.NEW_FILTER_BTN} !important;
  font-size: ${props.theme.fonts.fontSize.body.bodytext.copy3}px !important;
  font-weight: ${props.theme.fonts.fontWeight.semiBold} !important;}
 }`
      : ''}
`;

export const RankingWrapper = styled.div`
  display: flex;
  ${(props) =>
    props.pageName === 'PDP' &&
    props.isNewPJPPDPRedesignEnabled &&
    `justify-content: space-between;
  align-items-center;`}
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${(props) => props.isPDPRedesignEnabled && `justify-content:unset; `}
  }
`;

export const CustomRankingContainer = styled.div`
  text-align: left;
  ${(props) => (props?.isTileRedesignAB || props?.isRatingRedesignAbTest ? '' : 'height: 20px;')}
  display: flex;
  flex: 1;
  ${(props) => props.pageName === 'PDP' && props.isNewPJPPDPRedesignEnabled && `margin-top: 2px;`}
  img {
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) =>
        !(props?.isTileRedesignAB || props?.isRatingRedesignAbTest)
          ? `min-width:${props.isBagPage || props.isConfirmationPage ? '70px;' : '100px;'}`
          : ''}
    }
    width: ${(props) => (props.isBagPage ? '70px' : '100px')};
    ${(props) =>
      props?.isTileRedesignAB || props?.isRatingRedesignAbTest
        ? 'height: 11px;width:60px;margin-top:6px;'
        : 'height: 17px;'}
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props?.isTileRedesignAB || props?.isRatingRedesignAbTest
          ? `height: 9px;width:58px;color:${props?.theme?.colors?.TEXT?.DARKERGRAY};font-weight:500`
          : ' height: 15px;'}
      ${(props) =>
        props.pageName === 'PDP' && props.isNewPJPPDPRedesignEnabled
          ? 'width: 80px;'
          : 'width: 72px;'}
      ${(props) => (props?.isTileRedesignAB || props?.isRatingRedesignAbTest ? 'width:58px;' : '')}
    }
  }
`;

export const RatingStarOverlay = styled.span`
  ${(props) => props.pageName === 'PDP' && `cursor: pointer`};
  position: absolute;
  overflow: hidden;
  width: calc(
    ${(props) =>
      `(${props.ratings} / 5) * ${
        (!(props?.isTileRedesignAB || props?.isRatingRedesignAbTest)
          ? props.starRatingSize && props.starRatingSize.large
          : '60') || 100
      }px`}
  );

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: calc(
      ${(props) =>
        `(${props.ratings} / 5) * ${
          (!(props?.isTileRedesignAB || props?.isRatingRedesignAbTest)
            ? props.starRatingSize && props.starRatingSize.small
            : '58') || 72
        }px`}
    );

    ${(props) =>
      props.isPDPRedesignEnabled &&
      `
    line-height: 0;
    `}
  }
`;

export const RatingStarYellow = styled(Image)`
  background-color: ${(props) =>
    props.isNewPJPPDPRedesignEnabled
      ? `${
          props.isTileRedesignAB || props?.isRatingRedesignAbTest || props?.isPDPRedesignEnabled
            ? props?.theme?.colors?.TEXT?.DARKERGRAY
            : '#EEC533'
        }`
      : `${
          props.isTileRedesignAB ||
          props?.isRatingRedesignAbTest ||
          props?.isPDPRedesignEnabled ||
          props?.stickyAtbHeader
            ? props?.theme?.colors?.TEXT?.DARKERGRAY
            : props.theme.colorPalette.yellow[600]
        }`};
  max-width: initial;
  ${(props) =>
    props?.isTileRedesignAB || props?.isRatingRedesignAbTest
      ? 'max-width:60px;margin-top:4px;height:11px'
      : ''}
  display: inline;
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) =>
      props.isNewPDPEnabled
        ? `
      margin-bottom: 5px;
    `
        : ''}
  }
`;

export const RatingStarGrey = styled(Image)`
  ${(props) => props.pageName === 'PDP' && `cursor: pointer`};
  background-color: ${(props) => props.theme.colorPalette.gray[500]};
  display: inline;
  ${(props) => (props?.isTileRedesignAB || props?.isRatingRedesignAbTest ? 'max-width:60px;' : '')}
`;

export const ReviewsCount = styled(BodyCopy)`
  ${(props) => props.pageName === 'PDP' && `cursor: pointer`};
  color: ${(props) =>
    props.isNewPJPPDPRedesignEnabled
      ? props.theme.colorPalette.gray[800]
      : props.theme.colorPalette.gray[600]};
  vertical-align: top;
  display: inline-block;
  ${(props) =>
    props?.isTileRedesignAB || props?.isRatingRedesignAbTest
      ? 'margin-top: 4px;'
      : 'margin-top: 2px;'}
  margin-left: 2px;
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
  ${(props) => getNewPJPRedesignIfEnabled(props)}
  ${(props) =>
    props?.isTileRedesignAB || props?.isRatingRedesignAbTest
      ? `color:${props?.theme?.colors?.TEXT?.DARKERGRAY};font-weight:${props.theme.fonts.fontWeight.medium};`
      : ''};

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) =>
      props?.isTileRedesignAB || props?.isRatingRedesignAbTest
        ? `font-weight:${props.theme.fonts.fontWeight.semiBold};`
        : ''};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy1}px;
  }
`;

export const ReviewsCountRedesign = styled(BodyCopy)`
  ${(props) => props.pageName === 'PDP' && `cursor: pointer`};
  color: ${(props) =>
    props.isNewPJPPDPRedesignEnabled
      ? props.theme.colorPalette.gray[800]
      : props.theme.colorPalette.gray[900]};
  vertical-align: top;
  display: inline-block;
  margin-top: 2px;
  margin-left: 2px;
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
  ${(props) => getNewPJPRedesignIfEnabled(props)}
  ${(props) =>
    props.isNewPDPEnabled
      ? `
    text-decoration: underline;
  `
      : ''}
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      props.isNewPDPEnabled
        ? `
      margin-left: 6px;
    `
        : ''}
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) =>
      props.isNewPDPEnabled
        ? `
      margin-top: 0;
    `
        : ''}
  }
  ${(props) =>
    props?.isPDPRedesignEnabled &&
    `
      color: ${props?.theme?.colors?.TEXT?.DARKERGRAY};
      margin-top: 0;
      `}
`;
export const SocialProofMessageWrapper = styled.div`
  & .social-proof-text {
    ${(props) =>
      props.pageName === 'PDP' && props.isNewPJPPDPRedesignEnabled
        ? ` margin-top: 20px;
  margin-left: 0px;`
        : ''}
  }
`;

export default css`
  .recommendations-container,
  .custom-ranking-container {
    ${(props) => (props?.isTileRedesignAB ? `margin-bottom: 0;` : '')};
    ${(props) =>
      props?.isRatingRedesignAbTest
        ? `margin-bottom:${props.theme.spacing.ELEM_SPACING.XS_1};`
        : ''}
  }
  .fav-count {
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    gap: 4px;
    margin-top: 2px;
  }
  .fav-count-bar {
    color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
  }
  .fav-count-num {
    color: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
    padding-top: 2px;
    padding-left: 2px;
  }
  .fav-heart-wrapper {
    display: flex;
    gap: 2px;
    cursor: pointer;
  }
  .newwrite-review-link-redesign {
    color: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: underline;
    padding-top: 2px;
    padding-right: 6px;
    cursor: pointer;
  }
`;
